import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SmartImage from 'dpl/components/SmartImage';
import {
  HOW_IT_WORKS_URL,
  LEARNING_CENTER_PATH,
  STANDARDS_PATH
} from 'dpl/shared/constants/urls';
import { isLessThanBreakpoint } from 'dpl/util/grid';

import howItWorksPng from 'dpl/assets/header/how_it_works.png';
import learningCenterPng from 'dpl/assets/header/learning_center.png';
import ourStandardsPng from 'dpl/assets/header/our_standards.png';

const IMAGE_SIZE = isLessThanBreakpoint('md') ? '64px' : '56px';

const MENU_ITEMS = [
  {
    label: 'How it works',
    image: howItWorksPng,
    href: HOW_IT_WORKS_URL
  },
  {
    label: 'Visit the learning center',
    image: learningCenterPng,
    href: LEARNING_CENTER_PATH
  },
  {
    label: 'Learn about our standards',
    image: ourStandardsPng,
    href: STANDARDS_PATH
  }
];

export default function PlatformInfoLinks({ className }) {
  return (
    <nav aria-label="Platform information">
      <ul className={classnames('PlatformInfoLinks', className)}>
        {MENU_ITEMS.map((item, index) => (
          <li
            key={item.label}
            className={classnames({
              'bt bt-0-ns b--default': index
            })}
          >
            <a
              className="flex items-center gap-16 md:gap-12 font-16 fw-medium br3 hover-bg-near-white pv4 ph4-md"
              href={item.href}
            >
              <SmartImage
                Tag="div"
                className="cover bg-center"
                src={item.image}
                height={IMAGE_SIZE}
                width={IMAGE_SIZE}
                preserveTag
                lazy
              />
              <span>{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

PlatformInfoLinks.propTypes = {
  className: PropTypes.string
};

PlatformInfoLinks.defaultProps = {
  className: null
};
